"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.convertDateFilterConfig = void 0;
var tslib_1 = require("tslib");
var sdk_model_1 = require("@gooddata/sdk-model");
var convertAllTime = function (allTime) {
    return tslib_1.__assign({ type: "allTime" }, allTime);
};
var convertAbsoluteForm = function (absoluteForm) {
    return tslib_1.__assign({ type: "absoluteForm" }, absoluteForm);
};
var convertRelativeForm = function (relativeForm) {
    var availableGranularities = relativeForm.granularities, other = tslib_1.__rest(relativeForm, ["granularities"]);
    return tslib_1.__assign({ type: "relativeForm", availableGranularities: availableGranularities }, other);
};
var convertAbsolutePreset = function (absolutePreset) {
    return tslib_1.__assign({ type: "absolutePreset" }, absolutePreset);
};
var convertRelativePreset = function (relativePreset) {
    return tslib_1.__assign({ type: "relativePreset" }, relativePreset);
};
exports.convertDateFilterConfig = function (dateFilterConfig) {
    var _a = dateFilterConfig.dateFilterConfig, _b = _a.content, selectedOption = _b.selectedOption, allTime = _b.allTime, absoluteForm = _b.absoluteForm, relativeForm = _b.relativeForm, absolutePresets = _b.absolutePresets, relativePresets = _b.relativePresets, meta = _a.meta;
    return {
        ref: sdk_model_1.uriRef(meta.uri),
        selectedOption: selectedOption,
        allTime: allTime && convertAllTime(allTime),
        absoluteForm: absoluteForm && convertAbsoluteForm(absoluteForm),
        relativeForm: relativeForm && convertRelativeForm(relativeForm),
        absolutePresets: absolutePresets && absolutePresets.map(convertAbsolutePreset),
        relativePresets: relativePresets && relativePresets.map(convertRelativePreset),
    };
};
//# sourceMappingURL=DateFilterConfigConverter.js.map